import React, { useState } from "react";

import InvestorRedeemSharesForm from "./InvestorRedeemSharesForm";
import { formatShareQty } from "../../utils/investorRedeemEligibility";
import { projectTitleWithCode } from "../../utils/projectViews";

/**
 * Redemption request modal — same form and platform limits as funded project redeem tab.
 */
export default function RedeemSharesRequestModal({ balance, onClose, onSuccess }) {
  const projectId = String(balance?.project_id || "").trim();
  const label =
    projectTitleWithCode({ project_code: balance?.project_code, name: balance?.project_name }) || "Project";
  const available = Number(balance?.shares_available_for_redemption || 0);
  const [successRef, setSuccessRef] = useState("");

  if (!balance || !projectId) return null;

  return (
    <div className="invx-about-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="invx-about-modal redeem-shares-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="redeem-modal-title"
      >
        <button type="button" className="invx-about-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h3 id="redeem-modal-title" style={{ marginTop: 0 }}>
          Redeem shares
        </h3>
        <p className="muted" style={{ margin: "0 0 12px" }}>
          {label}
        </p>
        {balance?.shares_pending_redemption > 0 ? (
          <p className="muted" style={{ fontSize: 13, margin: "0 0 14px" }}>
            Locked pending: <strong>{formatShareQty(balance.shares_pending_redemption)}</strong> shares
          </p>
        ) : null}

        {successRef ? (
          <div>
            <p className="msg msg-success">
              Redemption queued
              {successRef ? (
                <>
                  {" "}
                  — reference <strong>{successRef}</strong>
                </>
              ) : null}
              . Pending admin review; NAV and fees are fixed at approval.
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
              <button type="button" className="btn-secondary" onClick={onClose}>
                Done
              </button>
            </div>
          </div>
        ) : (
          <>
            <InvestorRedeemSharesForm
              projectId={projectId}
              available={available}
              className="stack"
              title=""
              subtitle=""
              submitLabel="Submit redeem request"
              onSuccess={(data) => {
                const ref = data?.redemption_ref || "";
                setSuccessRef(ref);
                onSuccess?.({ redemption_ref: ref, project_id: projectId });
              }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
